export default __webpack_public_path__ + "static/media/bg3.fb202cf6.jpg";